export interface TaskScenario {
    task_type: string;
    process_phase: string;
    title: string;
    description: string;
    instruction: string;
}

export const taskScenarios: TaskScenario[] = [
    {
        task_type: "status_query",
        process_phase: "entrada_tst",
        title: "Consultar status do processo",
        description: "Imagine que você entrou com um processo trabalhista contra uma empresa e quer verificar em que situação ele se encontra hoje.",
        instruction: "Use a interface abaixo para consultar o status do seu processo."
    },
    {
        task_type: "status_query",
        process_phase: "em_analise",
        title: "Verificar andamento",
        description: "Seu processo está sendo analisado pelo tribunal. Você quer saber em que ponto está a análise.",
        instruction: "Navegue pela interface para entender o que está acontecendo com seu processo."
    },
    {
        task_type: "status_query",
        process_phase: "em_julgamento",
        title: "Acompanhar julgamento",
        description: "Seu processo está próximo de ser julgado. Você quer saber quando e como será o julgamento.",
        instruction: "Encontre informações sobre a data e o formato do julgamento."
    },
    {
        task_type: "status_query",
        process_phase: "decisao_publicada",
        title: "Ver resultado",
        description: "O julgamento do seu processo foi realizado e você quer saber qual foi a decisão.",
        instruction: "Verifique o resultado do julgamento e se há alguma ação necessária."
    },
    {
        task_type: "decision_interpretation",
        process_phase: "entrada_tst",
        title: "Entender a distribuição",
        description: "Seu processo chegou ao TST e foi distribuído para um Ministro. Você quer entender o que isso significa.",
        instruction: "Leia a interface e tente compreender o que acontecerá a seguir."
    },
    {
        task_type: "decision_interpretation",
        process_phase: "em_analise",
        title: "Compreender a análise",
        description: "O processo está em análise. Você quer entender o que está sendo analisado e quanto tempo pode levar.",
        instruction: "Explore a interface para encontrar informações sobre o andamento da análise."
    },
    {
        task_type: "decision_interpretation",
        process_phase: "em_julgamento",
        title: "Entender o julgamento",
        description: "O processo foi incluído em pauta de julgamento. Você quer entender o que isso significa.",
        instruction: "Use a interface para compreender como funciona o julgamento no TST."
    },
    {
        task_type: "decision_interpretation",
        process_phase: "decisao_publicada",
        title: "Entender a decisão",
        description: "Uma decisão foi publicada no seu processo e você precisa entender o que ela significa para você.",
        instruction: "Leia a interface e tente compreender se a decisão foi favorável e quais são os próximos passos."
    }
];

export function getScenario(taskType: string, processPhase: string): TaskScenario | undefined {
    return taskScenarios.find(
        s => s.task_type === taskType && s.process_phase === processPhase
    );
}

export function getDefaultScenario(taskIndex: number): TaskScenario {
    // Return a scenario based on task index for fallback
    return taskScenarios[taskIndex % taskScenarios.length];
}
